<app-section-wrapper-container>
	<div class="overview-sub-section">
		<app-summary-brief
			class="bg-gradient-to-r from-yellow-600 via-yellow-500 to-amber-400 border border-yellow-400"
			[svgIcon]="types | getIconFromOptions: this.recordData().type"
			[title]="'customers|title'"
			[value]="
				this.recordData().type | getTranslationKeyFromValue: types | transloco
			">
			<div class="flex flex-col sm:flex-row gap-4 w-full">
				<div class="brief-item">
					<app-summary-item
						forceWhiteText
						[title]="'contact-card|phone-mobile'"
						[value]="this.recordData().contactPhoneMobile" />
				</div>
				<div class="brief-item">
					<app-summary-item
						forceWhiteText
						[title]="'contact-card|email'"
						[value]="recordData().contactEmail" />
				</div>
			</div>
		</app-summary-brief>
	</div>
	@if (!isNew) {
		<app-module-selector
			[nav]="nav()"
			[isNew]="isNew"
			[recordId]="recordData().id" />
	}
</app-section-wrapper-container>
